import React, { createContext, useContext, useEffect, useState } from "react";
import staffApi from "@/lib/staffApi";

const StaffContext = createContext(null);
export const useStaff = () => useContext(StaffContext);

export const ROLE_LEVEL = { junior: 1, admin: 2, super: 3 };
export const roleLabel = { junior: "Junior Admin", admin: "Admin", super: "Super Admin" };

export function StaffProvider({ children }) {
  const [staff, setStaff] = useState(null); // null=checking, false=guest, obj=staff

  useEffect(() => {
    staffApi.get("/staff/auth/me").then((r) => setStaff(r.data)).catch(() => setStaff(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await staffApi.post("/staff/auth/login", { email, password });
    setStaff(data.user); return data.user;
  };
  const register = async (name, email, password, invite_code) => {
    const { data } = await staffApi.post("/staff/auth/register", { name, email, password, invite_code });
    setStaff(data.user); return data.user;
  };
  const logout = async () => {
    try { await staffApi.post("/staff/auth/logout"); } catch { /* ignore */ }
    setStaff(false);
  };
  const can = (minRole) => staff && ROLE_LEVEL[staff.role] >= ROLE_LEVEL[minRole];

  return <StaffContext.Provider value={{ staff, login, register, logout, can }}>{children}</StaffContext.Provider>;
}
